// extracted by mini-css-extract-plugin
export default {"homeSliderA":"HomeSlider_homeSliderA__h4joO","homeSliderB":"HomeSlider_homeSliderB__mQAsN","homeSliderC":"HomeSlider_homeSliderC__IzCOn"};